exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ps-container .ps__rail-y{z-index:1015!important}", ""]);

// exports
